import { render, staticRenderFns } from "./forPc.vue?vue&type=template&id=dae9c446&scoped=true"
import script from "./forPc.vue?vue&type=script&lang=js"
export * from "./forPc.vue?vue&type=script&lang=js"
import style0 from "./forPc.vue?vue&type=style&index=0&id=dae9c446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae9c446",
  null
  
)

export default component.exports